<template>
<!-- 销售记录 -->
<div class="viewContainer">
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="销售记录" name="first"/>
    <el-tab-pane label="赠送记录" name="second"/>
  </el-tabs>
  <!-- 销售记录列表 -->
  <div class="main_container" v-show="activeName=='first'">
    <section class="model_section"><p class="model_top_title">销售记录</p></section>
    <div class="table_container">
    <el-table :data="xsjlList" stripe border>
      <el-table-column label="序号" align="center" width="60">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column label="账号" align="center">
        <template scope="scope">
          <span :title="scope.row.buyer"> {{scope.row.buyer}}</span>
        </template>
      </el-table-column>
      <el-table-column label="支付金额" align="center">
        <template scope="scope">
          <span :title="scope.row.price"> {{scope.row.price}} 元</span>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" align="center">
        <template scope="scope">
          <span :title="scope.row.buytime"> {{scope.row.buytime}}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否退款" align="center">
        <template scope="scope">
          <span :title="scope.row.isrefund"> {{scope.row.isrefund==0?'否':'是'}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next" @current-change="currentChangeOne"
    :page-size="10" :total="totalOne" :current-page="pageIndexOne" style="float:right;margin: 10px 0;"/>
    </div>
  </div>
  <!-- 赠送记录列表 -->
  <div class="main_container" v-show="activeName=='second'">
    <section class="model_section">
      <p class="model_top_title">赠送记录</p>
      <div style="float: right;margin-right: 10px;">
        <el-button type="danger" @click="addGive()">新增赠送</el-button>
      </div>
    </section>
    <div class="table_container">
    <el-table :data="zsjlList" stripe border>
      <el-table-column label="序号" align="center" width="60">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column label="账号" align="center">
        <template scope="scope">
          <span :title="scope.row.buyer"> {{scope.row.buyer}}</span>
        </template>
      </el-table-column>
      <el-table-column label="赠送次数" align="center">
        <template scope="scope">
          <span :title="scope.row.num"> {{scope.row.num}} 次</span>
        </template>
      </el-table-column>
      <el-table-column label="赠送时间" align="center">
        <template scope="scope">
          <span :title="scope.row.buytime"> {{scope.row.buytime}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center">
        <!-- <template scope="scope">
          <span class="handle" @click="delGive(scope.row)"> <i class="el-icon-delete"></i> 删除 </span>
        </template> -->
        <span class="handle"> - </span>
      </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next" @current-change="currentChangeTwo"
    :page-size="10" :total="totalTwo" :current-page="pageIndexTwo" style="float:right;margin: 10px 0;"/>
    </div>
  </div>
  
  <!-- 新增赠送 -->
  <el-dialog title="新增赠送" :visible.sync="showGive" width="26%" center>
    <el-form>
      <el-form-item label="账号：" style="display:flex;">
        <el-input v-model="giveNum" placeholder="请输入手机号" maxlength="11" style="width: 90%;"/>
      </el-form-item>
      <el-form-item label="次数：" style="display:flex;">
        <el-select v-model="csid" filterable placeholder="请选择次数" style="width: 90%;">
          <el-option v-for="item in giveFrequency" :key="item.id" :label="item.num" :value="item.pkgid"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="text-align:center">
      <el-button @click="showGive = false">取消</el-button>
      <el-button type="danger" @click="handleGive()">确定</el-button>
    </div>
  </el-dialog>

</div>
</template>
<script>
import { purchasedGetlist, productGetlist, productfreegift } from "../../api/shopWindow";
  export default {
    name: "salesRecords",
    data () {
      return {
        activeName: 'first', // tab切换标识

        xsjlList:[],
        pageIndexOne: 1,
        totalOne: 0,

        zsjlList: [],
        pageIndexTwo: 1,
        totalTwo: 0,

        showGive: false,
        giveNum: '',
        csid: 0,
        giveFrequency: [],
      }
    },
    methods: {
      // 切换tab
      handleClick(tab){
        if(tab.name=='first'){
          this.pageIndexOne = 1;
          this.initOne();
        }
        if(tab.name=='second'){
          this.pageIndexTwo = 1;
          this.initTwo();
        }
      },
      // 销售记录列表
      initOne(){
        let obj = {
          pageindex: this.pageIndexOne, // 页码
          pagesize: 10, // 条数
        }
        purchasedGetlist(obj).then(data=>{
          if(data.resultCode == 1){
            this.xsjlList = data.resultObj.list;
            this.totalOne = data.resultObj.totalcount;
          }else{
            this.xsjlList = [];
            this.totalOne = 0
          }
        })
      },
      // 分页
      currentChangeOne(val) {
        this.pageIndexOne = val;
        this.initOne()
      },
      // 赠送记录列表
      initTwo(){
        let obj = {
          isfreegift: 1, // 是否赠送 0=否 1=是
          pageindex: this.pageIndexTwo, // 页码
          pagesize: 10, // 条数
        }
        purchasedGetlist(obj).then(data=>{
          if(data.resultCode == 1){
            this.zsjlList = data.resultObj.list;
            this.totalTwo = data.resultObj.totalcount;
          }else{
            this.zsjlList = [];
            this.totalTwo = 0
          }
        })
      },
      // 分页
      currentChangeTwo(val) {
        this.pageIndexTwo = val;
        this.initTwo()
      },
      // 新增赠送
      addGive(){
        this.getGive();
        this.giveNum = '';
        this.csid = 0;
        this.showGive = true;
      },
      // 次数列表数据
      getGive(){
        let addParams = {
          pkgtype: 1, // 套餐包类型 1=交付宝套餐
        };
        productGetlist(addParams).then(data => {
          if (data.resultCode == 1) {
            // 添加单位到每个元素
            data.resultObj.forEach(item => {
              item.num += '次';
            });
            this.giveFrequency = data.resultObj;
            this.giveFrequency.unshift({
              pkgid: 0, num: "请选择"
            });
          }
        })
      },
      // 确定赠送
      handleGive(){
        if (this.giveNum == "") {
          this.$swal({
            text: "请输入账号",
            type: "warning"
          });
          return false;
        }
        if (this.csid == 0) {
          this.$swal({
            text: "请选择次数",
            type: "warning"
          });
          return false;
        }
        let obj = {
          businesstype: 1, // 赠送对象类型 1=C端用户-手机号 2=C端用户-用户ID 3=B端用户-商家ID 4=B端用户-企业ID
          businessid: this.giveNum, // 赠送对象值(用户手机号/用户ID/店铺ID/企业ID)
          pkgid: this.csid, // 套餐ID
        }
        productfreegift(obj).then(data => {
          if (data.resultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功",
            });
            this.showGive=false;
            this.initTwo();
          }else{
            this.$swal({
              type: "warning",
              text: data.resultMsg,
            })
          }
        });
      },
      // 删除
      delGive(row) {
        this.$swal({
          type: "warning",
          text: "重要信息，你确定要删除吗？",
          showCancelButton: true,
          reverseButtons: true, // 添加这一行来反转按钮顺序
          cancelButtonText: "取消",
          confirmButtonText: "确定",
        }).then((res) => {
          if (res.value) {
            var obj = {
              id: row.id
            };
            deleteComments(obj).then(data => {
              if (data.resultCode == 1) {
                this.$swal({
                  type: "success",
                  text: "删除成功",
                });
                this.initTwo();
              }
            });
          }
        });
      },
      
    },
    mounted() {
      this.initOne(); // 初始化查询列表
    },
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// salesRecords.vue?64b8b143